import { resolveApiAssetUrl } from "@/shared/api/api-client";

/** Quem a menção cita (2026-10-15): a "foto" do cliente — o logo da empresa,
 *  ou as iniciais da marca quando não há logo ou a menção é de concorrente — e
 *  o nome da marca; menção de concorrente leva o selo "Concorrente". */
export function MentionClient({
  brandName,
  companyName,
  isCompetitor,
  logoUrl
}: {
  brandName: string;
  companyName: string;
  isCompetitor: boolean;
  logoUrl: string | null;
}) {
  const initials = brandName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0]?.toUpperCase() ?? "")
    .join("");
  return (
    <div className={`mc-client${isCompetitor ? " is-competitor" : ""}`}>
      <span className={`mc-client-avatar${logoUrl ? " has-logo" : ""}`} aria-hidden="true">
        {logoUrl ? <img src={resolveApiAssetUrl(logoUrl)} alt="" /> : initials}
      </span>
      <strong className="mention-row-brand" title={isCompetitor ? `${brandName} (concorrente: ${companyName})` : brandName}>
        {brandName}
      </strong>
      {isCompetitor && <span className="mc-client-competitor">Concorrente</span>}
    </div>
  );
}
